import { render } from "./Search.vue?vue&type=template&id=0d59559f&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0d59559f"

export default script